import React from 'react';
import styled from 'styled-components';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import SectionHeader from '../../../_molecules/SectionHeader';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';
import { BodyLarge, H3 } from '@styled';
import { mediaQueries } from '@general/breakpoints';
import MessagesSettingsForm from '../../../_organisms/MessagesSettingsForm';

import useDocumentTitle from '@hooks/useDocumentTitle';

const breakpoint = mediaQueries.md;

const ContainerStyled = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    @media ${breakpoint} {
        padding-left: 0;
        padding-right: 0;
    }
`;

const MessagesSettingsPage = () => {
    const { documentTitle } = useDocumentTitle('My ICSC Messages Settings');

    return (
        <ErrorHandler>
            <TrackPageView>
                <ContainerStyled>
                    <SectionHeader title={documentTitle} />

                    <SectionBreadcrumbs className="mt-2">
                        <SectionBreadcrumb route="/my-icsc/messages">Messages</SectionBreadcrumb>
                        <SectionBreadcrumb isActive>Settings</SectionBreadcrumb>
                    </SectionBreadcrumbs>

                    <H3 className="mt-3 mb-3">Settings</H3>
                    <BodyLarge>Manage your messaging and notification settings.</BodyLarge>

                    <MessagesSettingsForm />
                </ContainerStyled>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default MessagesSettingsPage;
